/**
 * The window which renames a skin.
 *
 * One window for a whole screen of them. The pencil pressed says which skin
 * it is about - where the answer goes and what the name is now - and both are
 * written into the form before the window opens. A form of its own on every
 * card would be the same two fields repeated once for every skin the portal
 * offers, in a card too narrow to hold them.
 *
 * Everything the window does otherwise is a plain form posting to the
 * administration, so nothing here decides anything: it fills in an address
 * and gets out of the way.
 */

import { dialogsWork } from "./modal";
import { query, queryAll } from "../core/dom";

/** Marks a pencil which opens the window. */
export const RENAME = "data-skin-rename";

/** Wire the pencils of the page to the one window which renames a skin. */
export function initSkinRename(): void {
    const dialog = query<HTMLDialogElement>("[data-skin-rename-dialog]");
    if (!dialog || !dialogsWork()) {
        return;
    }

    const form = query<HTMLFormElement>("[data-skin-rename-form]", dialog);
    const field = query<HTMLInputElement>("[data-skin-rename-name]", dialog);

    if (!form || !field) {
        return;
    }

    for (const pencil of queryAll<HTMLElement>(`[${RENAME}]`)) {
        pencil.addEventListener("click", () => {
            const action = pencil.getAttribute("data-skin-rename-action");
            if (!action) {
                return;
            }

            form.action = action;
            field.value = pencil.getAttribute("data-skin-rename-value") ?? "";
            dialog.showModal();

            // Selected rather than merely focused: renaming is far more often
            // writing another name than adding a letter to this one.
            field.select();
        });
    }

    dialog.addEventListener("click", (event: Event) => {
        const target = event.target;
        if (target instanceof Element && target.closest("[data-skin-rename-cancel]")) {
            event.preventDefault();
            dialog.close();
        }
    });
}
